import React from "react";
import axios from "axios";
import Card from "./Cards";
import { image, icon, formatSearchDescription } from "../helpers";

let timeout;

class SearchBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searches: [],
      error: null
    };
  }

  emptiesSearchesOnClick = e => {
    this.refs.searchInput.value = "";
    this.setState({ searches: [] });
  };

  search = e => {
    let value = e.target.value;

    clearTimeout(timeout);

    timeout = setTimeout(() => {
      if (!value) return this.setState({ searches: [], error: null });

      if (value.length > 2) {
        axios
          .get("search/multi", { params: { query: value } })
          .then(response => {
            this.setState({ searches: response.data.results.slice(0, 2) });

            if (!response.data.results.length)
              this.setState({ error: "Nothing matches the given entry :/" });
            else this.setState({ error: null });
          });
      }
    }, 750);
  };

  render() {
    return (
      <div className="mb-4 p-4 pb-4 rounded border-b-2 shadow hover:shadow-md transition">
        <div className="relative">
          <input
            className="w-full outline-none italic pl-10 shadow appearance-none border rounded py-2 px-3 text-grey-darker leading-tight"
            placeholder="i.e. The Handmaid's Tale"
            onChange={this.search}
            ref="searchInput"
            type="search"
            autoFocus
          />
          <div className="pointer-events-none absolute pin-y pin-l pl-3 flex items-center">
            <svg
              className="fill-current pointer-events-none text-grey-dark w-4 h-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z" />
            </svg>
          </div>
        </div>

        {this.state.searches.length > 0 && (
          <div className="flex flex-wrap -mx-2 mt-2">
            {this.state.searches.map(search => {
              return (
                <Card
                  link={`/${search.media_type}/${search.id}`}
                  emptiesSearchesOnClick={this.emptiesSearchesOnClick}
                  description={formatSearchDescription(search)}
                  title={search.title || search.name}
                  image={image({
                    image: search,
                    w: 300,
                    h: 300,
                    type: search.media_type
                  })}
                  icon={icon(search.media_type)}
                  className="md:w-1/2 p-2 pb-0"
                  divClassName="justify-start"
                  key={search.id}
                />
              );
            })}
          </div>
        )}

        {this.state.error && (
          <p className="text-center mt-4">
            <strong>Shoot!</strong> {this.state.error}
          </p>
        )}
      </div>
    );
  }
}

export default SearchBar;



// WEBPACK FOOTER //
// ./src/components/SearchBar.js